module.exports = __webpack_public_path__ + "img/logo-kol.43c27740.png";